import styled from 'styled-components';

import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';

export const TabsWrapper = styled.div`
    display: block;
    user-select: none;
    width: 100%;
`;

export const TabsHead = styled.div`
    width: 100%;
    border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
    position: relative;
`;

export const TabsHeader = styled.div`
    flex-wrap: nowrap;
    width: 100%;
    justify-content: ${props => props.justify ? 'space-between' : 'flex-start'};
`;

export const TabsItem = styled.div`
    display: block;
    padding: 15px 0;
    white-space: nowrap;
    cursor: pointer;
    position: relative;
    ${props => props.active ? FONTS.MediumS : FONTS.S}
    &:not(:last-child) {
        margin-right: 30px;
    }
    &:hover {
        color: ${props => props.active ? COLORS.TextPrimary :  props.accentColor || COLORS.Logo};
    }
`;

export const Bar = styled.div`
    position: absolute;
    bottom: 0;
    height: 2px;
    background-color: ${props => props.accentColor || COLORS.Control};
    transition: width 0.4s ease-in-out, left 0.4s ease-in-out;
`;

export const Badge = styled.span`
    position: absolute;
    background: ${COLORS.LabelsText_1};
    border-radius: 10px;
    ${FONTS.XS};
    height: 20px;
    padding: 0 6px;
    color: white;
    right: -20px;
    top: 3px;
    text-align: center;
`;

export const HiddenTab = styled.div`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;
    opacity: 0;
    white-space: nowrap;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
`;
